<template>
    <aicc-stepper ref="temp" v-if="disabled" v-model="row.oldChannels" controlType="updown" :disabled="true" min="1" max="100" @input="onStepperChange" @change="onStepperChange"/>
    <aicc-stepper v-else v-model="row.channels" controlType="updown" :disabled="false" min="1" max ="100" @input="onStepperChange" @change="onStepperChange" :validCheck="true" :rules="rules"/>
<!--
    <custom-stepper ref="temp" v-if="disabled" v-model="row.oldChannels" controlType="updown" :disabled="true" min="1" max="100" @input="onStepperChange" @change="onStepperChange"/>
    <custom-stepper v-else v-model="row.channels" controlType="updown" :disabled="false" min="1" max ="100" @input="onStepperChange" @change="onStepperChange"/>
-->
</template>
<script>
import Base from './CMP_AIS_00005_COMP_BASE';

export default {
    name:'CMP_AIS_00005_C02',
    extends:Base,
    components:{
    },
    props:{
        //props : ['row','value','text'], 
    },
    data(){
        return {
            rules:[
                v => v != '' || '',
            ],
        }
    },
    created(){},
    mounted(){},
    computed:{
        disabled(){
            if(this.row.isNewNumber && this.row.isNewNumber === true) {
                return false;
            } else if(this.row.isChannelChange === true) {
                return true;
            } else if(this.row.oldStatusCode === 'D' && this.row.statusCode != 'E' ) {
                //this.row.channels = this.row.oldChannels;
                return false;
            }
            return true;
        },
    },
    methods:{
        onStepperChange(value){
            let parent = this.getComponent('ServiceRequestNewModal');
            //parent.items[this.row.__idx].channels = value;
            parent.onStepperChange(this.row.__idx, value);
        },
    },
}
</script>
